<div class="container">
  <h2>Import dashboard</h2>

  <div class="first-table">
    <div *ngIf="loadingFirst" class="text-center my-3">
      <div class="spinner-border text-primary" role="status"><span class="sr-only">Loading...</span></div>
    </div>

    <div *ngIf="errorFirst" class="alert alert-danger">{{errorFirst}}</div>

   <div class="table-container">
     <table *ngIf="!loadingFirst && !errorFirst" class="viewDataTable" id="tblFirst">
      <thead>
        <tr>
          <th class="viewDataTableHeading"></th>
          <th class="viewDataTableHeading">Provider</th>
          <th class="viewDataTableHeading">Type</th>
          <th class="viewDataTableHeading">Datetime</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of firstTableData" (click)="onSelectRow(row)" [class.table-active]="isSelected(row)">
          <td class="viewDataTableCell">
            <button class="btn btn-primary btn-sm" (click)="onSelectRow(row); $event.stopPropagation()">Select</button>
          </td>
          <td class="viewDataTableCell">{{row.iprovider}}</td>
          <td class="viewDataTableCell">{{row.itype}}</td>
          <td class="viewDataTableCell">{{row.datetimeFormatted}}</td>
        </tr>
      </tbody>
    </table>
   </div>
  </div>

  <div class="second-table mt-4">
    <div *ngIf="loadingSecond" class="text-center my-3">
      <div class="spinner-border text-secondary" role="status"><span class="sr-only">Loading...</span></div>
    </div>

    <div *ngIf="errorSecond" class="alert alert-danger">{{errorSecond}}</div>
 <div class="table-container">
    <table *ngIf="!loadingSecond && !errorSecond && secondTableData.length>0" class="viewDataTable" id="tblSecond">
      <thead>
        <tr>
          <th class="viewDataTableHeading">Provider</th>
          <th class="viewDataTableHeading">Type</th>
          <th class="viewDataTableHeading">Datetime</th>
          <th class="viewDataTableHeading">Result</th>
          <th class="viewDataTableHeading">Filename</th>
          <th class="viewDataTableHeading">Message</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of secondTableData">
          <td class="viewDataTableCell">{{row.iprovider}}</td>
          <td class="viewDataTableCell">{{row.itype}}</td>
          <td class="viewDataTableCell">{{row.idatetimeFormatted}}</td>
          <td class="viewDataTableCell">{{row.iresult}}</td>
          <td class="viewDataTableCell">{{row.ifilename}}</td>
          <td class="viewDataTableCell">{{row.imessage}}</td>
        </tr>
      </tbody>
    </table>
</div>
    <div *ngIf="!loadingSecond && !errorSecond && secondTableData.length==0" class="text-muted">No details to display. Select a row above.</div>
  </div>
</div>
